<template>
  <div class="header-nav" :class="{ 'nav-autohide': autoHide, 'nav-hidden': navHidden }">
    <!-- 左侧 Logo -->
    <div class="login-logo">
      <img src="../assets/img/logo.png" class="logo-icon" alt="logo" @dblclick="toggleFullscreen" @mouseenter="showFullscreenTipOnHover" @mouseleave="hideFullscreenTip">
      <img src="../assets/img/logo1.png" class="logo-text" @click="toggleStarRain" @mouseenter="showStarTipOnHover" @mouseleave="hideFullscreenTip">

      <!-- 气泡提示：第一张 logo 提示双击全屏 -->
      <transition name="fs-tip">
        <div v-if="showFullscreenTip" class="fs-tip" :style="{ left: fsTipLeft + 'px' }" @click.stop>
          <span class="fs-tip-arrow"></span>
          <span class="fs-tip-text">{{ fsTipText }}</span>
        </div>
      </transition>

      <!-- 气泡提示：第二张 logo1 提示星星雨（独立气泡，纵向错开避免与全屏气泡重叠） -->
      <transition name="fs-tip">
        <div v-if="showStarTip" class="fs-tip star-tip" :style="{ left: starTipLeft + 'px' }" @click.stop>
          <span class="fs-tip-arrow star-tip-arrow"></span>
          <span class="fs-tip-text">{{ starTipText }}</span>
        </div>
      </transition>

      <!-- 星星雨配置小卡片：数量密度 / 纯色 or 搭配色系 -->
      <div v-if="starRainActive && showStarRainConfig" class="star-rain-config" @mousedown.stop @touchstart.stop>
        <div class="srcfg-head">
          <span class="srcfg-title">✦ 星星雨</span>
          <button type="button" class="srcfg-close" @click="showStarRainConfig = false">×</button>
        </div>
        <div class="srcfg-row">
          <label class="srcfg-label">数量密度</label>
          <input type="range" class="srcfg-range" min="10" max="200" step="5" v-model.number="starRainConfig.density">
          <span class="srcfg-val">{{ starRainConfig.density }}</span>
        </div>
        <div class="srcfg-row">
          <label class="srcfg-label">模式</label>
          <div class="srcfg-modes">
            <button type="button" class="srcfg-mode" :class="{ on: starRainMode === 'pile' }" @click="setStarRainMode('pile')">堆积</button>
            <button type="button" class="srcfg-mode" :class="{ on: starRainMode === 'fall' }" @click="setStarRainMode('fall')">飘落</button>
          </div>
        </div>
        <div class="srcfg-row">
          <label class="srcfg-label">颜色</label>
          <div class="srcfg-modes">
            <button type="button" class="srcfg-mode" :class="{ on: starRainConfig.colorMode === 'mix' }" @click="starRainConfig.colorMode = 'mix'">搭配色系</button>
            <button type="button" class="srcfg-mode" :class="{ on: starRainConfig.colorMode === 'solid' }" @click="starRainConfig.colorMode = 'solid'">纯色</button>
          </div>
        </div>
        <div v-if="starRainConfig.colorMode === 'mix'" class="srcfg-row">
          <label class="srcfg-label">色系</label>
          <div class="srcfg-palettes">
            <button type="button" v-for="(p, key) in starRainPalettes" :key="key" class="srcfg-pal" :class="{ on: starRainConfig.palette === key }" :style="{ background: p.css }" @click="starRainConfig.palette = key" :title="p.name">{{ p.name }}</button>
          </div>
        </div>
        <div v-else class="srcfg-row">
          <label class="srcfg-label">纯色</label>
          <div class="srcfg-solids">
            <button type="button" v-for="c in starRainSolidColors" :key="c" class="srcfg-solid" :class="{ on: starRainConfig.solidColor === c }" :style="{ background: c }" @click="starRainConfig.solidColor = c" :title="c"></button>
          </div>
        </div>
        <div class="srcfg-row srcfg-btns">
          <button type="button" class="srcfg-pause" :class="{ paused: starRainPaused }" @click="toggleStarRainPause">
            {{ starRainPaused ? '▶ 继续下星' : '⏸ 暂停下星' }}
          </button>
        </div>
        <div class="srcfg-tip">飘落：自然下落消失 · 堆积：落地保留 · 长按左键吸星松开炸开 ✨</div>
      </div>

      <!-- 星星雨悬浮球：配置卡片收起后缩为一个小球，点击重新展开 -->
      <div v-if="starRainActive && !showStarRainConfig" class="star-rain-ball" @click="showStarRainConfig = true" title="星星雨设置">
        ✦
      </div>

      <!-- 手机端汉堡菜单：折叠全部导航项 -->
      <el-dropdown class="nav-mobile-menu" trigger="click" @command="handleSelect">
        <i class="el-icon-menu nav-mobile-btn"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">首页</el-dropdown-item>
          <el-dropdown-item command="5">粉裙物语</el-dropdown-item>
          <el-dropdown-item command="3">星际航行</el-dropdown-item>
          <el-dropdown-item command="4">世界之窗</el-dropdown-item>
          <el-dropdown-item command="2">地图相册</el-dropdown-item>
          <el-dropdown-item command="6">宇宙幻境</el-dropdown-item>
          <el-dropdown-item command="7">洛丽寻宝</el-dropdown-item>
          <el-dropdown-item command="9">物语小店</el-dropdown-item>
          <el-dropdown-item command="8">裙星空间</el-dropdown-item>

        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!-- 中央导航菜单 -->
    <el-menu
        ref="topMenu"
        :default-active="activeIndex2"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        text-color="#5c3a52"
        active-text-color="#e0539c">

      <el-menu-item index="1">首页</el-menu-item>
      <el-menu-item index="5">粉裙物语</el-menu-item>
      <el-menu-item index="3">星际航行</el-menu-item>

      <el-menu-item index="4">世界之窗</el-menu-item>

      <el-menu-item index="2">地图相册</el-menu-item>

      <el-menu-item index="6">宇宙幻境</el-menu-item>
      <el-menu-item index="7">洛丽寻宝</el-menu-item>
      <el-menu-item index="9">物语小店</el-menu-item>
      <el-menu-item index="8">裙星空间</el-menu-item>
      <el-menu-item class="more-menu-item" :class="{ 'more-active': moreDrawerVisible }" index="10" @click="toggleMoreDrawer">更多</el-menu-item>

    </el-menu>

    <!-- “更多”小抽屉：造梦空间 / 泣海遗愿（页面建设中，点击不跳转） -->
    <transition name="more-drawer-fade">
      <div v-if="moreDrawerVisible" class="more-drawer" :style="moreDrawerStyle" @click.stop>
        <div class="more-drawer-arrow" :style="moreDrawerArrowStyle"></div>
        <div class="more-drawer-head">
          <span class="more-drawer-title">✦ 更多空间</span>
          <span class="more-drawer-sub">新篇章 · 敬请期待</span>
        </div>
        <div class="more-drawer-grid">
          <div
              v-for="item in moreNavItems"
              :key="item.key"
              class="more-drawer-item"
              @click="onMoreItemClick(item)">
            <span class="more-drawer-icon">{{ item.icon }}</span>
            <span class="more-drawer-info">
              <span class="more-drawer-name-line">
                <span class="more-drawer-name">{{ item.name }}</span>
                <span v-if="!item.route" class="more-drawer-badge">建设中</span>
              </span>
              <span class="more-drawer-desc">{{ item.desc }}</span>
            </span>
          </div>
        </div>
      </div>
    </transition>

    <!-- 最右侧：登录 / 用户状态（保持在导航栏最右边） -->
    <div class="header-user-area">
      <template v-if="!user || !user.no">
        <el-button class="header-login-btn" type="primary" size="small" round @click="openDrawer">登录</el-button>
      </template>
      <template v-else>
        <el-button v-if="isAdminOrSuper" class="header-back-btn" type="warning" size="small" round @click="enterBackend">进入后台</el-button>
        <el-dropdown trigger="click" @command="handleUserCommand">
          <span class="header-user-name">
            <i class="el-icon-user-solid"></i>{{ user.name }}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="profile"><i class="el-icon-setting"></i>个人设置</el-dropdown-item>
            <el-dropdown-item command="notice" divided>
              <i class="el-icon-bell"></i>系统通知
              <span v-if="unreadNoticeCount > 0" class="header-notice-badge">{{ unreadNoticeCount > 99 ? '99+' : unreadNoticeCount }}</span>
            </el-dropdown-item>
            <el-dropdown-item command="feedback" divided>
              <i class="el-icon-chat-dot-round"></i>帮助反馈
            </el-dropdown-item>
            <el-dropdown-item command="logout" divided><i class="el-icon-switch-button"></i>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </div>

    <!-- 右侧滑出抽屉：登录 / 注册卡片 -->
    <el-drawer
        :visible.sync="drawerVisible"
        direction="rtl"
        size="420px"
        :with-header="false"
        custom-class="login-drawer"
        :modal-append-to-body="false">
      <div class="drawer-card">
        <div class="drawer-head">
          <div class="drawer-title chou_text_color2">{{ activeTab === 'login' ? '梦境空间·登录' : '梦境空间·注册' }}</div>
          <div class="drawer-sub">欢迎来到粉裙星物语</div>
        </div>

        <el-tabs v-model="activeTab" class="drawer-tabs">
          <!-- 登录卡片 -->
          <el-tab-pane label="登录" name="login">
            <el-form :model="loginForm" label-width="0" class="drawer-form" @submit.native.prevent>
              <el-form-item>
                <el-input v-model="loginForm.no" placeholder="请输入账号" prefix-icon="el-icon-user" clearable
                          autocomplete="off" size="medium"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="loginForm.password" type="password" placeholder="请输入密语" prefix-icon="el-icon-lock"
                          show-password autocomplete="off" size="medium" @keyup.enter.native="doLogin"></el-input>
              </el-form-item>
              <div class="login-security-box">
                <div class="login-security-title">🔐 账号安全须知</div>
                <div class="login-security-text">
                  <p>一、请妥善保管您的账号与密语，切勿告知他人。</p>
                  <p>二、账号仅限本人使用，请勿转借、转租或转让。</p>
                  <p>三、发现账号异常或被盗用，请及时联系管理员处理。</p>
                  <p>四、平台不会以任何理由索要您的密语，谨防诈骗。</p>
                  <p>五、公共设备登录请勿勾选“记住密语”，使用后及时退出。</p>
                  <p>六、平台内容仅供个人娱乐，陌生访问者浏览后离开。</p>
                  <p>七、本平台为个人开发学习使用，仅供个人娱乐</p>
                </div>
              </div>
              <el-form-item>
                <el-button class="drawer-submit" type="primary" size="medium" :loading="loggingIn" @click="doLogin">登 录</el-button>
              </el-form-item>
              <div class="drawer-tip">
                <el-link type="primary" style="color: rgb(23,191,255)" @click="wu">遗失密语</el-link>
                <span @click="switchToRegister" class="drawer-switch">没有账号？去注册 →</span>
              </div>
            </el-form>
          </el-tab-pane>

          <!-- 注册卡片 -->
          <el-tab-pane label="注册" name="register">
            <el-form :model="regForm" label-width="0" class="drawer-form" @submit.native.prevent>
              <el-form-item>
                <el-input v-model="regForm.no" placeholder="请输入账号（3-20位）" prefix-icon="el-icon-user" clearable
                          autocomplete="off" size="medium"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="regForm.name" placeholder="请输入昵称" prefix-icon="el-icon-postcard" clearable
                          autocomplete="off" size="medium"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="regForm.password" type="password" placeholder="请输入密语（3-20位）" prefix-icon="el-icon-lock"
                          show-password autocomplete="off" size="medium"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="regForm.phone" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone" clearable
                          autocomplete="off" size="medium"></el-input>
              </el-form-item>
              <el-form-item>
                <div class="drawer-sex-row">
                  <span class="drawer-sex-label">性别</span>
                  <el-radio-group v-model="regForm.sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="0">女</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <el-form-item>
                <!-- 用户协议：注册前必须阅读并勾选同意 -->
                <div class="drawer-agreement">
                  <div class="drawer-agreement-box">
                    <div class="drawer-agreement-title">《粉裙星物语用户协议》</div>
                    <div class="drawer-agreement-text">
                      <p>欢迎注册并使用粉裙星物语。在注册之前，请您仔细阅读并理解以下条款：</p>
                      <p>一、账号注册：请提供真实、准确的注册信息，注册成功后您将获得本平台账号，账号仅限本人使用，不得转让、出借或出售。</p>
                      <p>二、账号安全：请您妥善保管账号与密码，因您保管不善造成的损失由您自行承担；发现账号被盗用请及时联系管理员。</p>
                      <p>三、行为规范：不得发布、传播违法违规、色情低俗、虚假欺诈、侵犯他人权益的内容；不得利用平台从事任何非法活动。</p>
                      <p>四、仅供娱乐：上传内容仅供娱乐，但平台也将依法保护您的个人信息。</p>
                      <p>五、星裙币：星裙币为平台内虚拟资产，仅限个人在平台内消费使用，不可兑换现金、不提供回购。</p>
                      <p>六、隐私保护：平台将依法保护您的个人信息，未经您的同意不向第三方披露（法律法规另有规定的除外）。</p>
                      <p>七、仅限娱乐：平台为个人开发学习使用，仅供个人娱乐游玩，不提供任何商业用途。</p>
                      <p>八、本平台仅限测试和娱乐，请勿用于任何商业用途。</p>
                      <p>九、如对本协议有任何疑问，请联系管理员。</p>
                    </div>
                  </div>
                  <el-checkbox v-model="regAgreed" class="drawer-agreement-check">
                    我已阅读并同意<span class="agreement-link" @click.stop.prevent="agreementVisible = true">《用户协议》</span>
                  </el-checkbox>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button class="drawer-submit" type="success" size="medium" :loading="registering" @click="doRegister">注 册</el-button>
              </el-form-item>
              <div class="drawer-tip">
                <span @click="switchToLogin" class="drawer-switch">已有账号？去登录 →</span>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>

    <!-- ===== 个人设置弹窗 ===== -->
    <el-dialog title="🌸 个人设置" :visible.sync="profileVisible" width="520px"
               custom-class="profile-dialog" append-to-body
               @closed="resetProfileForm">
      <div class="profile-edit">
        <el-upload
            class="profile-avatar-uploader"
            :action="avatarUploadUrl"
            name="file"
            accept="image/*"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="onAvatarUploadSuccess"
            :on-error="onAvatarUploadError">
          <el-avatar :size="72" :src="profileForm.avatar || null" class="profile-avatar">
            {{ (profileForm.name || '星').slice(0, 1) }}
          </el-avatar>
          <div class="profile-avatar-hint">📷 点击更换头像</div>
        </el-upload>

        <el-form :model="profileForm" label-width="72px" class="profile-form">
          <el-form-item label="昵称">
            <el-input v-model="profileForm.name" maxlength="20" placeholder="请输入昵称"></el-input>
          </el-form-item>
          <el-form-item label="年龄">
            <el-input v-model.number="profileForm.age" type="number" min="1" max="150" placeholder="请输入年龄"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="profileForm.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="0">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="profileForm.phone" maxlength="11" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="旧密码" v-if="profileForm.newPassword">
            <el-input v-model="profileForm.oldPassword" type="password" show-password
                      placeholder="请输入当前密码验证身份"></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input v-model="profileForm.newPassword" type="password" show-password
                      placeholder="留空表示不修改密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" v-if="profileForm.newPassword">
            <el-input v-model="profileForm.confirmPassword" type="password" show-password
                      placeholder="再次输入新密码"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="profileVisible = false">取 消</el-button>
        <el-button type="primary" :loading="savingProfile" @click="saveProfile">保 存</el-button>
      </span>
    </el-dialog>

    <!-- ===== 系统通知卡片弹窗：列表 + 内容详情 ===== -->
    <el-dialog title="🌸 系统通知" :visible.sync="noticeVisible" width="640px"
               custom-class="notice-dialog" append-to-body
               @open="onNoticeOpen" @closed="onNoticeClosed">
      <!-- 列表视图 -->
      <div v-if="noticeView === 'list'" class="notice-card">
        <div v-if="noticeLoading" class="notice-empty">正在加载通知...</div>
        <div v-else-if="!noticeList.length" class="notice-empty">
          <i class="el-icon-bell"></i>
          <p>暂无系统通知</p>
        </div>
        <ul v-else class="notice-list">
          <li v-for="item in noticeList" :key="item.noticeId" class="notice-item"
              :class="{ 'is-unread': item.isRead !== 'Y' }" @click="showNoticeDetail(item)">
            <div class="notice-item-head">
              <span class="notice-item-title">{{ item.title }}</span>
              <el-tag v-if="item.isRead !== 'Y'" type="danger" size="mini" effect="light">未读</el-tag>
              <el-tag v-else type="info" size="mini" effect="plain">已读</el-tag>
            </div>
            <div class="notice-item-meta">
              <span>{{ item.senderName || '系统' }}</span>
              <span class="notice-item-time">{{ formatTime(item.createTime) }}</span>
            </div>
          </li>
        </ul>
        <div v-if="noticeTotal > noticeList.length" class="notice-more" @click="loadMyNotices(false)">加载更多通知</div>
      </div>
      <!-- 详情视图 -->
      <div v-else class="notice-card">
        <div class="notice-detail">
          <div class="notice-detail-title">{{ currentNotice.title }}</div>
          <div class="notice-detail-meta">
            <span>{{ currentNotice.senderName || '系统' }} · {{ formatTime(currentNotice.createTime) }}</span>
          </div>
          <div class="notice-detail-content">{{ currentNotice.content }}</div>
        </div>
        <div class="notice-detail-back" @click="noticeView = 'list'">← 返回通知列表</div>
      </div>
    </el-dialog>

    <!-- ===== 用户协议完整弹窗 ===== -->
    <el-dialog title="《粉裙星物语用户协议》" :visible.sync="agreementVisible" width="540px"
               custom-class="agreement-dialog" :modal-append-to-body="false">
      <div class="agreement-full">
        <p>欢迎注册并使用粉裙星物语。请您在注册前仔细阅读并理解本协议全部条款，特别是涉及账号安全、行为规范、隐私保护等内容。您勾选同意并完成注册，即视为您已阅读、理解并同意本协议。</p>
        <p>一、账号注册：请提供真实、准确的注册信息，注册成功后您将获得本平台账号，账号仅限本人使用，不得转让、出借或出售。</p>
        <p>二、账号安全：请您妥善保管账号与密码，因您保管不善造成的损失由您自行承担；发现账号被盗用请及时联系管理员。</p>
        <p>三、行为规范：不得发布、传播违法违规、色情低俗、虚假欺诈、侵犯他人权益的内容；不得利用平台从事任何非法活动。</p>
        <p>四、星裙币：星裙币为平台内虚拟资产，仅限平台内个人消费使用，仅供娱乐，不可兑换现金、不提供回购。</p>
        <p>五、隐私保护：平台将依法保护您的个人信息，未经您的同意不向第三方披露（法律法规另有规定的除外）。</p>
        <p>六、服务变更与终止：平台仅供个人娱乐游玩，不提供任何商业用途。</p>
        <p>七、仅供娱乐：平台为个人开发学习使用，仅供娱乐，仅供娱乐！！！！！</p>
        <p>八、法律适用与争议解决：本协议适用中华人民共和国法律；因本协议产生的争议，双方应友好协商解决，协商不成的，提交平台所在地有管辖权的人民法院处理。</p>
        <p>九、本平台仅限测试和娱乐，请勿用于任何商业用途。</p>
        <p>十、如对本协议有任何疑问，请联系管理员。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreementVisible = false">我知道了</el-button>
      </span>
    </el-dialog>

    <!-- ===== 帮助反馈弹窗：管理员=全部反馈+直接处理；普通用户=提交+我的反馈状态 ===== -->
    <el-dialog :title="isAdmin ? '🌸 帮助反馈 · 管理' : '🌸 帮助反馈'" :visible.sync="feedbackVisible" width="560px"
               custom-class="feedback-dialog" append-to-body
               @opened="onFeedbackOpened" @closed="resetFeedbackForm">
      <!-- 超级管理员：查看所有用户反馈 + 直接点击确定处理 -->
      <template v-if="isAdmin">
        <div class="feedback-list-title">📮 全部用户反馈</div>
        <div v-if="feedbackLoading" class="feedback-empty">正在加载反馈...</div>
        <div v-else-if="!fbManageList.length" class="feedback-empty">
          <i class="el-icon-chat-dot-round"></i>
          <p>还没有用户提交反馈</p>
        </div>
        <ul v-else class="feedback-list">
          <li v-for="item in fbManageList" :key="item.id" class="feedback-item">
            <div class="feedback-item-user">
              <span class="feedback-user-name">{{ item.userName }}</span>
              <span class="feedback-user-no">{{ item.userNo }}</span>
            </div>
            <div class="feedback-item-content">{{ item.content }}</div>
            <div class="feedback-item-meta">
              <span>提交于 {{ formatTime(item.createTime) }}</span>
              <el-tag :type="item.status === 'completed' ? 'success' : 'warning'" size="mini" disable-transitions>
                {{ item.status === 'completed' ? '已完成' : '待处理' }}
              </el-tag>
            </div>
            <div v-if="item.status === 'completed' && item.finishTime" class="feedback-item-finish">
              处理完成：{{ formatTime(item.finishTime) }}
            </div>
            <div class="feedback-item-actions">
              <el-button v-if="item.status === 'pending'" type="primary" size="mini" round
                         :loading="fbFinishingId === item.id" @click="finishFeedbackItem(item)">确 定</el-button>
              <span v-else class="feedback-done-text">已处理</span>
            </div>
          </li>
        </ul>
      </template>

      <!-- 普通用户：提交反馈 + 我的反馈状态 -->
      <template v-else>
        <div class="feedback-send">
          <div class="feedback-send-title">告诉我们你的问题或建议</div>
          <el-input v-model="feedbackForm.content" type="textarea" :rows="4" maxlength="1000" show-word-limit
                    placeholder="请描述你遇到的问题，或想提出的建议…"></el-input>
          <div class="feedback-send-actions">
            <el-button type="primary" round :loading="feedbackSending" @click="doFeedback">提 交 反 馈</el-button>
          </div>
        </div>

        <div class="feedback-list-title">📮 我的反馈状态</div>
        <div v-if="feedbackLoading" class="feedback-empty">正在加载反馈...</div>
        <div v-else-if="!feedbackList.length" class="feedback-empty">
          <i class="el-icon-chat-dot-round"></i>
          <p>还没有提交过反馈</p>
        </div>
        <ul v-else class="feedback-list">
          <li v-for="item in feedbackList" :key="item.id" class="feedback-item">
            <div class="feedback-item-content">{{ item.content }}</div>
            <div class="feedback-item-meta">
              <span>提交于 {{ formatTime(item.createTime) }}</span>
              <el-tag :type="item.status === 'completed' ? 'success' : 'warning'" size="mini" disable-transitions>
                {{ item.status === 'completed' ? '已完成' : '待处理' }}
              </el-tag>
            </div>
            <div v-if="item.status === 'completed' && item.finishTime" class="feedback-item-finish">
              处理完成：{{ formatTime(item.finishTime) }}
            </div>
          </li>
        </ul>
      </template>
    </el-dialog>

    <!-- ===== 每日首次登录：用户须知和安全协议 ===== -->
    <el-dialog title="🌸 用户须知和安全协议" :visible.sync="dailyNoticeVisible" width="520px"
               custom-class="daily-notice-dialog" append-to-body
               :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <div class="daily-notice-content">
        <p>欢迎使用粉裙星物语！为了您和他人的良好体验，请仔细阅读并遵守以下须知：</p>
        <p>1. 遵守国家法律法规，文明上网，不发布违法违规、色情低俗、谣言及侵犯他人权益的内容。</p>
        <p>2. 请妥善保管个人账号与密码，勿将账号转借、转让他人使用。</p>
        <p>3. 本平台仅限测试和娱乐，请勿用于任何商业用途。</p>
        <p>4. 平台内星裙币等虚拟资产仅限平台内使用，请注意理性消费。</p>
        <p>5. 如发现违规内容或异常情况，请及时联系平台管理员处理。</p>
        <p>6. 平台有权依据法律法规对违规账号采取限制或封禁措施。</p>
        <p>7. 平台不承担因用户使用本平台而导致的任何损失或责任。</p>
        <p>8. 平台为个人开发学习使用</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="daily-notice-optout">
          <el-checkbox v-model="dailySkipToday">今天不再弹出</el-checkbox>
        </div>
        <el-button type="primary" @click="closeDailyNotice">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 全局头部导航栏（登录页 / 笔记页共用，保证两页头部完全一致）
 * - 左侧 Logo、右侧登录/用户状态、中央导航菜单
 * - 首页 → / ；关于我们 → /Notes ；分类项 → 首页对应板块（#style 风格介绍 / #showcase 样例展示）
 * - 登录抽屉全局可用，任意页面都可登录/注册/退出
 */
import { login, register, updateProfile } from '../api/user'
import { myNotices, readNotice, unreadCount } from '../api/notice'
import { addFeedback, myFeedbacks, manageFeedbacks, finishFeedback } from '../api/feedback'
import request from '../api/request'
import bus from '../utils/bus'
import { formatTime } from '../utils/format'

export default {
  name: 'HeaderNav',
  props: {
    // 自动隐藏：进入页面 5 秒后向上淡出，鼠标靠近屏幕顶部再滑入（默认关闭，不影响其它页面）
    autoHide: {
      type: Boolean,
      default: false
    },
    // 进入页面后多久自动隐藏（毫秒）
    autoHideDelay: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      activeIndex2: '1',
      // ===== “更多”小抽屉：更多导航入口 =====
      moreDrawerVisible: false,
      moreDrawerStyle: { left: '0px', top: '60px' },
      moreDrawerArrowStyle: { left: '26px' },
      moreNavItems: [
        { key: '10-1', name: '造梦空间', icon: '💭', desc: '梦境碎片收集' },
        { key: '10-2', name: '泣海遗愿', icon: '🌊', desc: '泪海深处的约定' },
        { key: '10-3', name: '潮玩天地', icon: '🧸', desc: '潮玩大冒险', route: '/MiniGames' },
        { key: '10-4', name: '英语记忆', icon: '📖', desc: '单词记忆小屋', route: '/Language' },
        { key: '10-5', name: '梦境空间', icon: '🌌', desc: '手办幻想画廊', route: '/SpaceDreams' },
        { key: '10-6', name: '童话魔法', icon: '🕰️', desc: '时光魔法书', route: '/TimeAlbum' },
        { key: '10-7', name: '时光相册', icon: '💫', desc: '照片回忆录', route: '/Memoirs' },
        { key: '10-8', name: '心愿烟花', icon: '🎆', desc: '点击放烟花', route: '/Fireworks' }
      ],
      // ===== 自动隐藏导航相关状态（仅 autoHide 时生效）=====
      navHidden: false,        // 当前是否已滑出屏幕
      navArmed: false,         // 首次计时结束后才允许自动隐藏
      navAutoTimer: null,      // 首次自动隐藏计时器
      navRehideTimer: null,    // 鼠标离开顶部后再次滑出的延时
      navRevealZone: 72,       // clientY 小于该值视为「靠近屏幕顶部」→ 滑入
      navKeepZone: 150,        // clientY 大于该值视为已离开顶部 → 安排滑出
      navTouchRevealStart: 100, // 触屏：触摸起点 clientY 小于该值才算「从顶部下拉」
      navTouchStartX: null,    // 触屏：最近一次触摸起点 X（用于识别下拉手势）
      navTouchStartY: null,    // 触屏：最近一次触摸起点 Y（用于识别下拉手势）
      drawerVisible: false,
      activeTab: 'login',
      loggingIn: false,
      registering: false,
      user: {},
      // 双击全屏引导气泡
      showFullscreenTip: false,
      fullscreenTipTimer: null,
      isFullscreen: false,
      // 气泡文字与水平位置（第一张 logo=全屏提示，第二张 logo=星星雨提示）
      fsTipText: '',
      fsTipLeft: 8,
      // logo1（星星雨）独立引导气泡：网页打开时自动弹出后消失，与全屏气泡纵向错开
      showStarTip: false,
      starTipText: '',
      starTipLeft: 130,
      starTipTimer: null,
      // 星星雨：点击 logo 文字图开启/关闭
      starRainActive: false,
      starRainTimer: null,
      // 星星雨配置（开启后显示配置小卡片）
      showStarRainConfig: true,
      starRainConfig: {
        density: 25,             // 数量密度：开启时初始生成数 / 下落生成速度
        colorMode: 'mix',        // 'mix' 搭配色系 | 'solid' 纯色
        solidColor: '#ffd1e8',   // 纯色模式选中的颜色
        palette: 'pink'          // 搭配色系：pink 粉嫩 / purple 梦幻紫 / starry 星空白 / rainbow 彩虹
      },
      starRainMode: 'fall',      // 'fall' 飘落消失（默认，自然下落出屏消失）| 'pile' 堆积保留（落地堆积不消失）
      starRainPaused: false,     // 手动暂停/继续生成
      starRainPalettes: {
        pink:   { name: '粉嫩',   css: 'linear-gradient(135deg,#ffd1e8,#e0539c)' },
        purple: { name: '梦幻紫', css: 'linear-gradient(135deg,#e0c3fc,#9b6dff)' },
        starry: { name: '星空白', css: 'linear-gradient(135deg,#ffffff,#7ec8ff)' },
        rainbow: { name: '彩虹',  css: 'linear-gradient(135deg,#ff9ecb,#ffd166,#9fd6a5,#7ec8ff)' }
      },
      starRainSolidColors: ['#ffd1e8', '#ff9ecb', '#e0539c', '#ffd700', '#b18cff', '#7ec8ff', '#9fd6a5', '#ff6fb3', '#ffffff'],
      // 个人设置弹窗
      profileVisible: false,
      savingProfile: false,
      profileForm: {
        no: '',
        name: '',
        age: null,
        sex: 0,
        phone: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        avatar: ''
      },
      loginForm: {
        no: '',
        password: ''
      },
      regForm: {
        no: '',
        name: '',
        password: '',
        phone: '',
        sex: ''
      },
      // 注册协议勾选与完整协议弹窗
      regAgreed: false,
      agreementVisible: false,
      // 系统通知卡片
      noticeVisible: false,
      noticeLoading: false,
      noticeList: [],
      noticeTotal: 0,
      noticePage: 1,
      noticePageSize: 10,
      noticeView: 'list',
      currentNotice: null,
      unreadNoticeCount: 0,
      // 每日首次登录：用户须知和安全协议
      dailyNoticeVisible: false,
      dailySkipToday: false,
      // 帮助反馈
      feedbackVisible: false,
      feedbackSending: false,
      feedbackLoading: false,
      feedbackList: [],
      // 超级管理员：全部用户反馈
      fbManageList: [],
      fbFinishingId: null,
      feedbackForm: {
        content: ''
      }
    }
  },
  computed: {
    // 管理员(roleId=1)或超级管理员(roleId=0)可进入后台
    isAdminOrSuper() {
      return this.user && (this.user.roleId === 0 || this.user.roleId === 1)
    },
    // 超级管理员：帮助反馈弹窗显示管理视图（查看全部反馈并直接处理）
    isAdmin() {
      return !!(this.user && this.user.roleId === 0)
    },
    // 登录权限控制开关：仅生产构建（VUE_APP_ACCESS_CONTROL=true）启用，本地开发默认关闭
    accessControlOn() {
      return process.env.VUE_APP_ACCESS_CONTROL === 'true'
    },
    // 超级管理员（roleId=0）才可访问“更多”里的功能
    isSuperAdmin() {
      return !!(this.user && this.user.roleId === 0)
    },
    avatarUploadUrl() {
      return request.defaults.baseURL + '/api/uploadAvatar'
    }
  },
  watch: {
    // 路由变化时同步菜单选中态
    $route: {
      immediate: true,
      handler(route) {
        // 先同步导航选中态（不依赖任何可能出错的前置逻辑）
        if (route.path === '/Notes') this.activeIndex2 = '8'
        else if (route.path === '/Storyshop') this.activeIndex2 = '9'
        else if (route.path === '/Universe') this.activeIndex2 = '6'

        else if (route.path === '/Lolita-JK-HanFu') this.activeIndex2 = '5'
        else if (route.path === '/Travel') this.activeIndex2 = '3'
        else if (route.path === '/World') this.activeIndex2 = '4'
        else if (route.path === '/MapTracking') this.activeIndex2 = '2'
        else if (route.path === '/LolitaTreasure') this.activeIndex2 = '7'
        // 从“更多”抽屉进入的页面：统一高亮“更多”
        else if (['/Language', '/SpaceDreams', '/TimeAlbum', '/Memoirs', '/MiniGames'].indexOf(route.path) !== -1) this.activeIndex2 = '10'
        else this.activeIndex2 = '1'
        // 最后再处理星星雨等副作用（异常不影响选中态）
        try {
          if (this.starRainActive) this.toggleStarRain()
        } catch (e) { /* 忽略 */ }
      }
    },
    // 选中态变化时兜底同步 el-menu 内部高亮（不重建菜单，避免点击行为受影响）
    activeIndex2(val) {
      this.$nextTick(() => {
        const menu = this.$refs.topMenu
        if (menu && typeof menu.updateActiveIndex === 'function') {
          menu.updateActiveIndex(val)
        }
      })
    },
    // 自动隐藏导航栏显隐变化时广播给页面（用于跟随导航栏移动的元素，如视觉小说右上角系统栏）
    navHidden(val) {
      if (this.autoHide) bus.$emit('nav-hidden-change', val)
    },
    // 星星雨数量密度变化 → 重启生成定时器（生效于下落速度）
    'starRainConfig.density': function () {
      this.updateStarRainTimer()
    }
  },
  created() {
    // 星星雨粒子系统：非响应式状态（避免每帧触发 Vue 渲染）
    this._stars = []
    this._pointer = { active: false, x: -9999, y: -9999 }
    this._starRaf = null
    this._starRainEl = null
    // 星星雨流体状态：吸引/炸开状态；长按检测定时器
    this._attracting = false
    this._attractTimer = null
    this._starDownAt = 0
    // 恢复登录状态：刷新页面后头部仍显示账号名/进入后台
    const cu = sessionStorage.getItem('CurUser')
    if (cu) {
      try {
        this.user = JSON.parse(cu)
      } catch (e) {
        this.user = {}
      }
    }
    // 已登录时恢复未读通知角标
    if (this.user && this.user.no) {
      this.refreshUnread()
    }
    // 支持其他页面（如裙星空间）唤起登录抽屉（具名处理器，便于销毁时解绑）
    bus.$on('open-login-drawer', this.openLoginDrawer)
    // 若菜单已丢失（如刷新后），用缓存菜单恢复动态路由
    if (this.user && this.user.no && this.$store.state.menu.length === 0) {
      const cm = sessionStorage.getItem('CurMenu')
      if (cm) {
        try {
          this.$store.commit('setMenu', JSON.parse(cm))
        } catch (e) {
          console.warn('恢复菜单失败', e)
        }
      }
    }
  },
  mounted() {
    // 刷新后展示「双击 Logo 全屏」引导气泡（10 秒后自动消失）
    document.addEventListener('click', this.handleDocClick)
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)
    this.showFullscreenTipOnce()
    // 刷新后展示「点击 Logo1 开启星星雨」引导气泡（与全屏气泡纵向错开，10 秒后自动消失）
    this.showStarTipOnce()

    // ===== 星星雨：跟踪鼠标 / 触屏指针，供排斥交互使用 =====
    document.addEventListener('mousemove', this.handleStarPointerMove)
    document.addEventListener('touchmove', this.handleStarPointerMove, { passive: true })
    document.addEventListener('mouseleave', this.handleStarPointerLeave)
    document.addEventListener('touchend', this.handleStarPointerLeave)
    // ===== 星星雨：长按左键吸引 / 松开炸开 =====
    document.addEventListener('mousedown', this.handleStarPointerDown)
    document.addEventListener('mouseup', this.handleStarPointerUp)
    document.addEventListener('touchstart', this.handleStarPointerDown, { passive: true })
    document.addEventListener('touchend', this.handleStarPointerUp, { passive: true })

    // ===== 自动隐藏导航：进入页面 N 秒后向上淡出，鼠标靠近顶部再滑入 =====
    if (this.autoHide) {
      this.startNavAutoTimer()
      window.addEventListener('mousemove', this.handleNavMouseMove, { passive: true })
      window.addEventListener('touchstart', this.handleNavTouchStart, { passive: true })
      window.addEventListener('touchmove', this.handleNavTouchMove, { passive: true })
      document.addEventListener('mouseleave', this.handleDocMouseLeave)
      // iframe 页面（如心愿烟花）会拦截顶部悬停事件，由子页面转发唤起/收起导航
      bus.$on('nav-reveal', this.showNav)
      bus.$on('nav-hide', this.scheduleHideNav)
    }
  },
  beforeDestroy() {
    // 与 bus.$on 配对解绑，避免组件复用时监听叠加泄漏
    bus.$off('open-login-drawer', this.openLoginDrawer)
    document.removeEventListener('click', this.handleDocClick)
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
    window.removeEventListener('mousemove', this.handleNavMouseMove)
    window.removeEventListener('touchstart', this.handleNavTouchStart)
    window.removeEventListener('touchmove', this.handleNavTouchMove)
    document.removeEventListener('mouseleave', this.handleDocMouseLeave)
    document.removeEventListener('mousemove', this.handleStarPointerMove)
    document.removeEventListener('touchmove', this.handleStarPointerMove)
    document.removeEventListener('mouseleave', this.handleStarPointerLeave)
    document.removeEventListener('touchend', this.handleStarPointerLeave)
    document.removeEventListener('mousedown', this.handleStarPointerDown)
    document.removeEventListener('mouseup', this.handleStarPointerUp)
    document.removeEventListener('touchstart', this.handleStarPointerDown)
    document.removeEventListener('touchend', this.handleStarPointerUp)
    this.removeMoreDocListener()
    bus.$off('nav-reveal', this.showNav)
    bus.$off('nav-hide', this.scheduleHideNav)
    clearTimeout(this._attractTimer)
    clearTimeout(this.fullscreenTipTimer)
    clearTimeout(this.starTipTimer)
    clearTimeout(this.navAutoTimer)
    clearTimeout(this.navRehideTimer)
    clearTimeout(this._logoClickTimer)
    clearInterval(this.starRainTimer)
    this.stopStarRainLoop()
    this.clearStars()
    if (this._starRainEl && this._starRainEl.parentNode) {
      this._starRainEl.parentNode.removeChild(this._starRainEl)
    }
    this._starRainEl = null
  },
  methods: {
    formatTime,

    // ================= 自动隐藏导航 =================
    // 进入页面后倒计时，时间到就向上淡出
    startNavAutoTimer() {
      clearTimeout(this.navAutoTimer)
      this.navAutoTimer = setTimeout(() => {
        this.navArmed = true
        this.navHidden = true
      }, this.autoHideDelay)
    },
    // 滑入：鼠标靠到屏幕顶部
    showNav() {
      clearTimeout(this.navRehideTimer)
      if (this.navHidden) this.navHidden = false
    },
    // 延时滑出：鼠标已离开顶部，留一点缓冲避免掠过时闪烁
    scheduleHideNav() {
      clearTimeout(this.navRehideTimer)
      this.navRehideTimer = setTimeout(() => {
        if (this.navArmed) this.navHidden = true
      }, 400)
    },
    handleNavMouseMove(e) {
      if (!this.autoHide || !this.navArmed) return
      const y = e.clientY
      if (y <= this.navRevealZone) {
        this.showNav()
      } else if (y > this.navKeepZone) {
        this.scheduleHideNav()
      }
    },
    // 鼠标移出窗口（如切到其它窗口/触摸板划出）→ 立刻收起
    handleDocMouseLeave() {
      if (this.autoHide && this.navArmed) {
        clearTimeout(this.navRehideTimer)
        this.navHidden = true
      }
    },
    // ===== 触屏：普通点击不弹出导航栏，仅「从顶部向下滑动」时滑入 =====
    // 记录触摸起点；若导航栏当前已显示且点击位置在导航栏之外，则按桌面端习惯延时收起
    handleNavTouchStart(e) {
      if (!this.autoHide) return
      const t = e.touches && e.touches[0]
      if (!t) return
      this.navTouchStartX = t.clientX
      this.navTouchStartY = t.clientY
      if (!this.navHidden && t.clientY > this.navRevealZone) {
        this.scheduleHideNav()
      }
    },
    // 触摸滑动中：起点在屏幕顶部 + 明显向下滑动（纵向位移大于横向）→ 滑入导航栏
    handleNavTouchMove(e) {
      if (!this.autoHide) return
      const t = e.touches && e.touches[0]
      if (!t) return
      if (this.navTouchStartY === null || this.navTouchStartY === undefined) return
      const dy = t.clientY - this.navTouchStartY
      const dx = t.clientX - this.navTouchStartX
      const startFromTop = this.navTouchStartY <= this.navTouchRevealStart
      if (startFromTop && dy > 24 && dy > Math.abs(dx)) {
        this.navTouchStartY = null // 同一次触摸只触发一次
        this.navArmed = true
        this.showNav()
      }
    },

    openLoginDrawer() {
      this.drawerVisible = true
    },
    // ===== “更多”小抽屉：定位 / 开关 / 外部点击关闭 =====
    toggleMoreDrawer() {
      if (this.moreDrawerVisible) {
        this.closeMoreDrawer()
        return
      }
      this.positionMoreDrawer()
      this.moreDrawerVisible = true
      // 渲染完成后按实际宽度修正右边界，避免窄窗口下抽屉溢出屏幕
      this.$nextTick(() => {
        const el = this.$el.querySelector('.more-drawer')
        if (!el) return
        const maxLeft = window.innerWidth - el.offsetWidth - 8
        const curLeft = parseFloat(this.moreDrawerStyle.left)
        if (curLeft > maxLeft) {
          this.moreDrawerStyle = {
            ...this.moreDrawerStyle,
            left: Math.max(0, Math.round(maxLeft)) + 'px'
          }
        }
      })
      this.addMoreDocListener()
    },
    positionMoreDrawer() {
      const el = this.$el.querySelector('.more-menu-item')
      if (!el) return
      const rect = el.getBoundingClientRect()
      // 导航栏固定在视口顶部，其内部绝对定位可直接使用视口坐标
      this.moreDrawerStyle = {
        left: Math.round(rect.left) + 'px',
        top: Math.round(rect.bottom) + 'px'
      }
      // 小箭头对准“更多”文字中心
      const arrowLeft = Math.min(Math.max(rect.width / 2 - 6, 10), 180)
      this.moreDrawerArrowStyle = { left: Math.round(arrowLeft) + 'px' }
    },
    addMoreDocListener() {
      this.removeMoreDocListener()
      this._moreDocHandler = e => {
        const drawer = this.$el.querySelector('.more-drawer')
        const moreItem = this.$el.querySelector('.more-menu-item')
        if (drawer && moreItem && !drawer.contains(e.target) && !moreItem.contains(e.target)) {
          this.closeMoreDrawer()
        }
      }
      this._moreResizeHandler = () => this.closeMoreDrawer()
      document.addEventListener('click', this._moreDocHandler)
      window.addEventListener('resize', this._moreResizeHandler)
    },
    removeMoreDocListener() {
      if (this._moreDocHandler) {
        document.removeEventListener('click', this._moreDocHandler)
        this._moreDocHandler = null
      }
      if (this._moreResizeHandler) {
        window.removeEventListener('resize', this._moreResizeHandler)
        this._moreResizeHandler = null
      }
    },
    closeMoreDrawer() {
      this.moreDrawerVisible = false
      this.removeMoreDocListener()
    },
    onMoreItemClick(item) {
      this.closeMoreDrawer()
      // 已开发页面：直接跳转；未开发页面：仅提示“建设中”
      if (item.route) {
        // 权限控制（仅生产开启）：非超级管理员点击 → 提示无权限，不跳转
        if (this.accessControlOn && !this.isSuperAdmin) {
          this.$message({
            type: 'warning',
            message: '🔒 没有操作权限，请使用超级管理员账号登录后访问',
            duration: 2500,
            customClass: 'more-tip-message'
          })
          return
        }
        this.$router.push(item.route)
        return
      }
      this.$message({
        type: 'info',
        message: '✨「' + item.name + '」页面建设中，敬请期待～',
        duration: 2000,
        customClass: 'more-tip-message'
      })
    },
    handleSelect(key) {
      if (!key) return
      // 取顶级菜单编号
      const first = key.split('-')[0]
      if (first === '10') {
        // “更多”：同步选中态（跳转由抽屉项触发，此处不跳转）
        this.activeIndex2 = '10'
      } else if (first === '8') {
        // 关于我们 → 我的笔记页面
        this.$router.push('/Notes')
      } else if (first === '9') {
        // 星物语小店
        this.$router.push('/Storyshop')
      } else if (first === '1') {
        // 首页 → 回到首页顶部
        this.$router.push({ path: '/' })
      } else if (first === '6') {
        // 宇宙幻境 → 进入梦幻粒子宇宙
        this.$router.push('/Universe')
      } else if(first === '5'){
        // 粉裙物语 → 进入对应板块
        this.$router.push({ path: '/Lolita-JK-HanFu'})
      } else if(first === '3'){
        // 星际航行 → 进入对应板块
        this.$router.push({ path: '/Travel'})
      } else if(first === '4'){
        // 世界之窗 → 进入对应板块
        this.$router.push({ path: '/World'})
      }else if(first === '2') {
        // 地图相册 → 进入对应板块
        this.$router.push({ path: '/MapTracking' })
      } else if(first === '7') {
        // 洛丽寻宝 → 进入抽卡寻宝页
        this.$router.push({ path: '/LolitaTreasure' })
      }
    },

    openDrawer() {
      this.drawerVisible = true
    },
    switchToRegister() {
      this.activeTab = 'register'
    },
    switchToLogin() {
      this.activeTab = 'login'
    },
    // 抽屉内登录：成功后不跳转后台，仅记录状态并收回抽屉
    doLogin() {
      if (!this.loginForm.no || !this.loginForm.password) {
        this.$message.warning('请输入账号和密语')
        return
      }
      this.loggingIn = true
      login(this.loginForm).then(res => {
        if (res.code === 200) {
          const user = res.data.user
          const menu = res.data.menu || []
          // 存储
          sessionStorage.setItem('CurUser', JSON.stringify(user))
          sessionStorage.setItem('CurMenu', JSON.stringify(menu))
          this.$store.commit('setMenu', menu)
          this.user = user
          this.drawerVisible = false
          this.loginForm = { no: '', password: '' }
          this.$message({
            type: 'success',
            message: '登录成功，欢迎 ' + user.name + '！'
          })
          // 刷新未读通知角标
          this.refreshUnread()
          // 除超级管理员外，每天首次登录弹出用户须知和安全协议
          this.checkDailyNotice()
          // 通知全局音乐卡片刷新显示（超级管理员登录后显示）
          bus.$emit('music:user-changed')
          // 通知各页面刷新登录用户信息（头像/星裙币等）
          bus.$emit('user-changed', user)
        } else {
          this.$message.error(res.msg || '校验失败，身份或密语错误！')
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后重试')
      }).finally(() => {
        this.loggingIn = false
      })
    },
    // 抽屉内注册：成功后切回登录卡片
    doRegister() {
      if (!this.regAgreed) {
        this.$message.warning('请先阅读并勾选同意《用户协议》')
        return
      }
      if (!this.regForm.no || !this.regForm.name || !this.regForm.password || !this.regForm.phone) {
        this.$message.warning('请完整填写注册信息')
        return
      }
      if (this.regForm.sex === '' || this.regForm.sex === null || this.regForm.sex === undefined) {
        this.$message.warning('请选择性别')
        return
      }
      this.registering = true
      register(this.regForm).then(res => {
        if (res.code === 200) {
          this.$message.success('注册成功，请登录')
          this.loginForm.no = this.regForm.no
          this.regForm = { no: '', name: '', password: '', phone: '', sex: '' }
          this.regAgreed = false
          this.activeTab = 'login'
        } else {
          this.$message.error(res.msg || '注册失败，请稍后重试')
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后重试')
      }).finally(() => {
        this.registering = false
      })
    },
    // 管理员/超级管理员进入后台系统
    enterBackend() {
      this.$router.push('/PersonalCenter')
    },
    handleUserCommand(cmd) {
      if (cmd === 'logout') {
        this.logout()
      } else if (cmd === 'profile') {
        this.openProfile()
      } else if (cmd === 'notice') {
        this.openNoticeCard()
      } else if (cmd === 'feedback') {
        this.openFeedback()
      }
    },
    openProfile() {
      this.profileForm = {
        no: this.user.no || '',
        name: this.user.name || '',
        age: this.user.age || null,
        sex: this.user.sex === 1 ? 1 : 0,
        phone: this.user.phone || '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        avatar: this.user.avatar || ''
      }
      this.profileVisible = true
    },
    resetProfileForm() {
      this.profileForm = {
        no: '', name: '', age: null, sex: 0, phone: '',
        oldPassword: '', newPassword: '', confirmPassword: '', avatar: ''
      }
    },
    // ===== 星星雨：单击 logo 文字图开/关（粒子不消失、落底堆积、长按吸引/松开炸开、配置卡片）=====
    toggleStarRain() {
      this.starRainActive = !this.starRainActive
      if (this.starRainActive) {
        // 容器直接挂到 body，与导航栏平级（导航栏 z-index 998 > 星星雨 996，星星被导航栏盖住）
        if (!this._starRainEl) {
          const el = document.createElement('div')
          el.className = 'star-rain'
          el.setAttribute('aria-hidden', 'true')
          document.body.appendChild(el)
          this._starRainEl = el
        }
        this.showStarRainConfig = true
        const n = Math.min(200, Math.max(10, this.starRainConfig.density))
        for (let i = 0; i < n; i++) {
          this.spawnStar()
        }
        this.updateStarRainTimer()
        this.startStarRainLoop()
      } else {
        clearInterval(this.starRainTimer)
        this.starRainTimer = null
        this.stopStarRainLoop()
        this.clearStars()
        clearTimeout(this._attractTimer)
        this._attracting = false
        if (this._starRainEl && this._starRainEl.parentNode) {
          this._starRainEl.parentNode.removeChild(this._starRainEl)
        }
        this._starRainEl = null
      }
    },
    spawnStar() {
      if (!this.starRainActive || this.starRainPaused) return
      const wrap = this._starRainEl
      if (!wrap) return
      // 堆积模式下满屏（达到容量）即停止生成，保持满屏状态
      if (this._stars.length >= 1600) {
        this.stopStarRainTimer()
        return
      }
      const chars = ['✦', '★', '✧', '⋆', '✩', '✫']
      const pal = this.starRainColors()
      const star = document.createElement('span')
      star.className = 'star-rain-item'
      star.textContent = chars[Math.floor(Math.random() * chars.length)]
      const size = 12 + Math.random() * 18
      star.style.fontSize = size + 'px'
      star.style.color = pal[Math.floor(Math.random() * pal.length)]
      wrap.appendChild(star)
      this._stars.push({
        el: star,
        x: Math.random() * window.innerWidth,
        y: -20 - Math.random() * 60,
        vx: (Math.random() - 0.5) * 0.6,
        vy: 0.1 + Math.random() * 0.15,
        rot: Math.random() * 360,
        vr: (Math.random() - 0.5) * 4,
        r: Math.max(13, size * 0.62),  // 物理碰撞半径（泡沫球直径一半）
        attracted: false               // 是否被长按吸引过（松开时瞬间炸开）
      })
    },
    // 粒子动画循环
    startStarRainLoop() {
      if (this._starRaf) return
      const tick = () => {
        this._starRaf = requestAnimationFrame(tick)
        this.stepStars()
      }
      this._starRaf = requestAnimationFrame(tick)
    },
    stopStarRainLoop() {
      if (this._starRaf) {
        cancelAnimationFrame(this._starRaf)
        this._starRaf = null
      }
    },
    // 每帧更新：流体粒子模拟（像一盒子泡沫球）
    // 重力下落 + 粒子间互斥挤压流动 + 盒壁（底部/两侧）+ 鼠标排斥 / 长按吸引 / 松开炸开
    stepStars() {
      const stars = this._stars
      const n = stars.length
      if (!n) return
      const ptr = this._pointer
      const W = window.innerWidth
      const H = window.innerHeight
      const R = 130            // 排斥影响半径（px）
      const ATTRACT_R = 340    // 长按吸引影响半径（px）
      const attracting = this._attracting

      // ① 重力 + 鼠标排斥/吸引（先作用于速度）
      for (let i = 0; i < n; i++) {
        const s = stars[i]
        // 温和重力：像雪花一样缓慢飘落
        s.vy += 0.04
        s.vx *= 0.99
        // 随机微风：下落时轻微左右摇摆（雪花感）
        s.vx += (Math.random() - 0.5) * 0.08
        if (ptr.active) {
          const dx = s.x - ptr.x
          const dy = s.y - ptr.y
          const dist = Math.sqrt(dx * dx + dy * dy)
          if (attracting) {
            // 长按：强力磁吸——星星被吸向鼠标并阻尼收敛，聚拢成团停在鼠标周围（松开时炸开）
            if (dist < ATTRACT_R && dist > 0.01) {
              s.attracted = true
              const pull = 1 - dist / ATTRACT_R   // 越靠近鼠标吸力越强
              const acc = 2.0 + pull * 4.0        // 向心加速度
              // 向鼠标方向（与排斥反向：星在右侧则速度向左）
              s.vx -= (dx / dist) * acc * 0.12
              s.vy -= (dy / dist) * acc * 0.12
              // 吸引阻尼：速度快速衰减，让星星粘在鼠标周围形成星团，不穿飞
              s.vx *= 0.82
              s.vy *= 0.82
            }
          } else if (dist < R && dist > 0.01) {
            // 普通排斥：温柔抛洒
            const force = (1 - dist / R) * 4.5
            s.vx += (dx / dist) * force
            s.vy += (dy / dist) * force
          }
        }
      }

      // ② 粒子间互斥：挤压流动、防止重叠（泡沫球堆在一起会自然滑动）
      // 空间哈希网格优化：只与相邻网格内的粒子碰撞，支撑上千粒子依然流畅
      const CELL = 56
      const gCols = Math.floor(W / CELL) + 1
      const gRows = Math.floor(H / CELL) + 1
      const head = new Int32Array(gCols * gRows).fill(-1)
      const next = new Int32Array(n)
      for (let i = 0; i < n; i++) {
        const s = stars[i]
        const cx = Math.max(0, Math.min(gCols - 1, Math.floor(s.x / CELL)))
        const cy = Math.max(0, Math.min(gRows - 1, Math.floor(s.y / CELL)))
        const b = cy * gCols + cx
        next[i] = head[b]
        head[b] = i
      }
      for (let i = 0; i < n; i++) {
        const s = stars[i]
        const cx = Math.max(0, Math.min(gCols - 1, Math.floor(s.x / CELL)))
        const cy = Math.max(0, Math.min(gRows - 1, Math.floor(s.y / CELL)))
        for (let gy = Math.max(0, cy - 1); gy <= Math.min(gRows - 1, cy + 1); gy++) {
          for (let gx = Math.max(0, cx - 1); gx <= Math.min(gCols - 1, cx + 1); gx++) {
            let j = head[gy * gCols + gx]
            while (j !== -1) {
              if (j > i) {
                const b = stars[j]
                const dx = b.x - s.x
                const dy = b.y - s.y
                const minD = s.r + b.r
                const d2 = dx * dx + dy * dy
                if (d2 < minD * minD && d2 > 0.0001) {
                  const d = Math.sqrt(d2)
                  // 温和松弛互斥：堆积的泡沫球缓慢滑动，不剧烈弹跳
                  const push = (minD - d) / d * 0.12
                  s.vx -= dx * push
                  s.vy -= dy * push
                  b.vx += dx * push
                  b.vy += dy * push
                }
              }
              j = next[j]
            }
          }
        }
      }

      // ③ 积分 + 盒壁碰撞（按模式：飘落出屏消失 / 堆积落地保留）
      const pileMode = this.starRainMode === 'pile'
      if (pileMode) {
        // 堆积模式：落地直接躺下保留，两侧/顶部挡回
        for (let i = 0; i < n; i++) {
          const s = stars[i]
          s.x += s.vx
          s.y += s.vy
          if (s.x < 0) { s.x = 0; s.vx = Math.abs(s.vx) * 0.4 }
          else if (s.x > W) { s.x = W; s.vx = -Math.abs(s.vx) * 0.4 }
          if (s.y < -30) { s.y = -30; s.vy = Math.abs(s.vy) * 0.4 }
          if (s.y >= H) {
            s.y = H
            s.vy = 0               // 落地直接躺下，不再反弹
            s.vx *= 0.85           // 地面摩擦
            if (Math.abs(s.vx) < 0.15) s.vx = 0
          }
          // 速度上限：防止粒子乱飞（炸开效果仍可达上限内）
          if (s.vx > 9) s.vx = 9
          else if (s.vx < -9) s.vx = -9
          if (s.vy > 12) s.vy = 12
          else if (s.vy < -12) s.vy = -12
          s.rot += s.vr
          if (s.el) {
            s.el.style.transform = 'translate(' + s.x + 'px,' + s.y + 'px) rotate(' + s.rot + 'deg)'
          }
        }
      } else {
        // 飘落模式：正常自然下落，出屏即消失（不堆积）
        for (let i = stars.length - 1; i >= 0; i--) {
          const s = stars[i]
          s.x += s.vx
          s.y += s.vy
          if (s.x < 0) { s.x = 0; s.vx = Math.abs(s.vx) * 0.4 }
          else if (s.x > W) { s.x = W; s.vx = -Math.abs(s.vx) * 0.4 }
          if (s.y < -30) { s.y = -30; s.vy = Math.abs(s.vy) * 0.4 }
          if (s.vx > 9) s.vx = 9
          else if (s.vx < -9) s.vx = -9
          if (s.vy > 12) s.vy = 12
          else if (s.vy < -12) s.vy = -12
          s.rot += s.vr
          if (s.el) {
            s.el.style.transform = 'translate(' + s.x + 'px,' + s.y + 'px) rotate(' + s.rot + 'deg)'
          }
          // 出屏消失
          if (s.y > H + 40) {
            if (s.el && s.el.parentNode) {
              s.el.parentNode.removeChild(s.el)
            }
            stars.splice(i, 1)
          }
        }
      }
    },
    // 清空所有星星（同时复位堆积与吸引状态）
    clearStars() {
      const stars = this._stars
      for (let i = 0; i < stars.length; i++) {
        if (stars[i].el && stars[i].el.parentNode) {
          stars[i].el.parentNode.removeChild(stars[i].el)
        }
      }
      stars.length = 0
      this._attracting = false
      clearTimeout(this._attractTimer)
    },
    // 按配置取星星颜色池（纯色 / 搭配色系）
    starRainColors() {
      const cfg = this.starRainConfig
      if (cfg.colorMode === 'solid') {
        return [cfg.solidColor]
      }
      const palettes = {
        pink: ['#ffd1e8', '#ff9ecb', '#e0539c', '#ffd700', '#ff6fb3', '#ffb6c1'],
        purple: ['#e0c3fc', '#b18cff', '#9b6dff', '#c9a0f2', '#d9c6ff', '#a78bfa'],
        starry: ['#ffffff', '#dcebff', '#a8d8ff', '#f0f6ff', '#7ec8ff', '#e6f2ff'],
        rainbow: ['#ff9ecb', '#ffd166', '#9fd6a5', '#7ec8ff', '#b18cff', '#ff8fb3']
      }
      return palettes[cfg.palette] || palettes.pink
    },
    // 星星雨生成间隔（ms）：数量密度越大越密集
    starRainInterval() {
      const d = Math.min(200, Math.max(10, this.starRainConfig.density))
      return Math.round(Math.max(16, 1400 / d))
    },
    // 密度配置变化后重启生成定时器（暂停或满屏时不重启）
    updateStarRainTimer() {
      if (!this.starRainActive || this.starRainPaused) return
      this.stopStarRainTimer()
      if (this._stars.length >= 1600) return
      this.starRainTimer = setInterval(() => {
        this.spawnStar()
      }, this.starRainInterval())
    },
    stopStarRainTimer() {
      clearInterval(this.starRainTimer)
      this.starRainTimer = null
    },
    // 切换星星雨模式：'fall' 飘落消失（默认）/ 'pile' 堆积保留
    setStarRainMode(mode) {
      if (mode !== 'fall' && mode !== 'pile') return
      if (this.starRainMode === mode) return
      this.starRainMode = mode
      if (!this.starRainActive) return
      // 切换模式后清空现有星星，按新模式重新开始
      this.clearStars()
      this.stopStarRainTimer()
      const n = Math.min(200, Math.max(10, this.starRainConfig.density))
      for (let i = 0; i < n; i++) {
        this.spawnStar()
      }
      if (!this.starRainPaused) this.updateStarRainTimer()
    },
    // 手动暂停 / 继续星星雨生成（已落下的星星继续存在与运动）
    toggleStarRainPause() {
      this.starRainPaused = !this.starRainPaused
      if (!this.starRainActive) return
      if (this.starRainPaused) {
        this.stopStarRainTimer()
      } else {
        this.updateStarRainTimer()
      }
    },
    // 长按左键（或触屏按住 380ms）进入吸引模式
    handleStarPointerDown(e) {
      if (!this.starRainActive) return
      if (e.type === 'mousedown' && e.button !== 0) return // 仅左键
      const t = e.touches ? e.touches[0] : e
      if (!t) return
      this._pointer.active = true
      this._pointer.x = t.clientX
      this._pointer.y = t.clientY
      this._starDownAt = Date.now()
      clearTimeout(this._attractTimer)
      this._attractTimer = setTimeout(() => {
        if (!this.starRainActive) return
        this._attracting = true
      }, 380)
    },
    // 松开左键 / 触屏抬起：被吸引的星星瞬间炸开
    handleStarPointerUp(e) {
      clearTimeout(this._attractTimer)
      const t = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e
      if (t && t.clientX !== undefined) {
        this._pointer.active = true
        this._pointer.x = t.clientX
        this._pointer.y = t.clientY
      }
      if (this.starRainActive && this._attracting) {
        this.explodeStars()
      }
      this._attracting = false
      this._pointer.active = false
    },
    // 炸开：被吸引过的星星向四周爆散（不消失，重新下落堆积）
    explodeStars() {
      const stars = this._stars
      let any = false
      for (let i = 0; i < stars.length; i++) {
        const s = stars[i]
        if (s.attracted) {
          s.attracted = false
          const ang = Math.random() * Math.PI * 2
          const sp = 6 + Math.random() * 15
          s.vx = Math.cos(ang) * sp
          s.vy = -(2 + Math.random() * 9)
          any = true
        }
      }
      // 若吸引期间恰好没有星被标记，把指针附近的星也炸开，反馈更明显
      if (!any && this._pointer.active) {
        const R = 260
        for (let i = 0; i < stars.length; i++) {
          const s = stars[i]
          const dx = s.x - this._pointer.x
          const dy = s.y - this._pointer.y
          if (Math.sqrt(dx * dx + dy * dy) < R) {
            const ang = Math.random() * Math.PI * 2
            const sp = 5 + Math.random() * 12
            s.vx = Math.cos(ang) * sp
            s.vy = -(2 + Math.random() * 8)
          }
        }
      }
    },
    // 鼠标 / 触屏指针跟踪（用于排斥交互）
    handleStarPointerMove(e) {
      const t = e.touches ? e.touches[0] : e
      if (!t) return
      this._pointer.active = true
      this._pointer.x = t.clientX
      this._pointer.y = t.clientY
    },
    handleStarPointerLeave() {
      this._pointer.active = false
    },
    // 双击 Logo 切换网页全屏
    toggleFullscreen() {
      const doc = document
      const el = doc.documentElement
      if (doc.fullscreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement) {
        const exitFn = doc.exitFullscreen || doc.webkitExitFullscreen || doc.msExitFullscreen
        if (exitFn) {
          const p = exitFn.call(doc)
          if (p && p.then) p.then(() => { this.isFullscreen = false }).catch(() => {})
          else this.isFullscreen = false
        }
      } else {
        const reqFn = el.requestFullscreen || el.webkitRequestFullscreen || el.msRequestFullscreen
        if (reqFn) {
          const p = reqFn.call(el)
          if (p && p.then) p.then(() => { this.isFullscreen = true }).catch(() => {})
          else this.isFullscreen = true
        }
      }
    },
    // ===== 双击全屏引导气泡 =====
    // showFullscreenTipOnce() {
    //   this.showFullscreenTip = true
    //   clearTimeout(this.fullscreenTipTimer)
    //   this.fullscreenTipTimer = setTimeout(() => {
    //     this.showFullscreenTip = false
    //   }, 10000)
    // },
    showFullscreenTipOnce() {
      // 已经显示过就不再显示
      if (sessionStorage.getItem('fullscreenTipShown')) {
        return
      }
      sessionStorage.setItem('fullscreenTipShown', '1')

      this.fsTipText = '双击 Logo 可进入全屏模式'
      this.fsTipLeft = 8
      this.showFullscreenTip = true
      clearTimeout(this.fullscreenTipTimer)
      this.fullscreenTipTimer = setTimeout(() => {
        this.showFullscreenTip = false
      }, 10000)
    },
    showFullscreenTipOnHover() {
      this.fsTipText = this.isFullscreen ? '再双击 Logo 可退出全屏' : '双击 Logo 可进入全屏模式'
      this.fsTipLeft = 8
      this.showFullscreenTip = true
    },
    showStarTipOnHover() {
      this.starTipText = this.starRainActive ? '关闭星星雨' : '开启星星雨'
      this.starTipLeft = 130
      this.showStarTip = true
    },
    // logo1（星星雨）首次进入页面自动弹出引导气泡，10 秒后自动消失
    showStarTipOnce() {
      // 已经显示过就不再显示
      if (sessionStorage.getItem('starTipShown')) {
        return
      }
      sessionStorage.setItem('starTipShown', '1')

      this.starTipText = '点击 Logo1 可开启星星雨'
      this.starTipLeft = 130
      this.showStarTip = true
      clearTimeout(this.starTipTimer)
      this.starTipTimer = setTimeout(() => {
        this.showStarTip = false
      }, 10000)
    },
    hideFullscreenTip() {
      clearTimeout(this.fullscreenTipTimer)
      this.showFullscreenTip = false
      clearTimeout(this.starTipTimer)
      this.showStarTip = false
    },
    handleDocClick() {
      // 点击页面其它任意位置，气泡立即消失
      this.hideFullscreenTip()
    },
    handleFullscreenChange() {
      this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement)
    },
    saveProfile() {
      if (!this.profileForm.name || !this.profileForm.name.trim()) {
        this.$message.warning('昵称不能为空')
        return
      }
      if (!this.profileForm.phone || !/^1[3-9]\d{9}$/.test(this.profileForm.phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      // 改密码时前端先校验
      const payload = {
        no: this.profileForm.no,
        name: this.profileForm.name.trim(),
        age: this.profileForm.age,
        sex: this.profileForm.sex,
        phone: this.profileForm.phone.trim(),
        avatar: this.profileForm.avatar
      }
      if (this.profileForm.newPassword) {
        if (!this.profileForm.oldPassword) {
          this.$message.warning('请输入旧密码')
          return
        }
        if (this.profileForm.newPassword !== this.profileForm.confirmPassword) {
          this.$message.warning('两次输入的新密码不一致')
          return
        }
        payload.oldPassword = this.profileForm.oldPassword
        payload.password = this.profileForm.newPassword
      }
      this.savingProfile = true
      updateProfile(payload).then(res => {
        if (res.code === 200) {
          this.$message.success('个人资料已更新 🌸')
          // 同步本地缓存与头部显示
          const fresh = res.data || {}
          this.user = Object.assign({}, this.user, fresh)
          this.user.password = undefined
          sessionStorage.setItem('CurUser', JSON.stringify(this.user))
          this.profileVisible = false
          // 通知其他页面刷新（裙星空间等）
          bus.$emit('music:user-changed')
          // 通知各页面刷新登录用户信息（头像/星裙币等）
          bus.$emit('user-changed', this.user)
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      }).catch(err => {
        this.$message.error(err.message || '保存失败')
      }).finally(() => {
        this.savingProfile = false
      })
    },
    beforeAvatarUpload(file) {
      if (!/^image\//.test(file.type)) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('头像大小不能超过 2MB')
        return false
      }
      return true
    },
    onAvatarUploadSuccess(res) {
      if (res && res.success && res.filePath) {
        this.profileForm.avatar = res.filePath
        this.$message.success('头像已更新，记得点保存 🌸')
      } else {
        this.$message.error((res && res.message) || '头像上传失败')
      }
    },
    onAvatarUploadError() {
      this.$message.error('头像上传失败，请稍后重试')
    },
    logout() {
      sessionStorage.removeItem('CurUser')
      sessionStorage.removeItem('CurMenu')
      this.user = {}
      this.unreadNoticeCount = 0
      this.$message.success('已退出登录')
      bus.$emit('music:user-changed')
      // 不跳页，刷新当前页，由各页面自行按未登录态展示
      window.location.reload()
    },
    // ===== 帮助反馈 =====
    openFeedback() {
      this.feedbackVisible = true
    },
    // 弹窗动画打开后按角色加载对应数据
    onFeedbackOpened() {
      if (this.isAdmin) {
        this.loadManageFeedback()
      } else {
        this.loadMyFeedback()
      }
    },
    // 加载我的反馈状态列表
    loadMyFeedback() {
      if (!this.user || !this.user.no) return
      this.feedbackLoading = true
      myFeedbacks({
        pageNum: 1,
        pageSize: 50,
        param: { no: this.user.no }
      }).then(res => {
        if (res.code === 200) {
          this.feedbackList = res.data || []
        } else {
          this.$message.error(res.msg || '获取反馈失败')
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后重试')
      }).finally(() => {
        this.feedbackLoading = false
      })
    },
    // 超级管理员：加载全部用户反馈
    loadManageFeedback() {
      this.feedbackLoading = true
      manageFeedbacks({
        pageNum: 1,
        pageSize: 50,
        param: { keyword: '' }
      }).then(res => {
        if (res.code === 200) {
          this.fbManageList = res.data || []
        } else {
          this.$message.error(res.msg || '获取反馈失败')
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后重试')
      }).finally(() => {
        this.feedbackLoading = false
      })
    },
    // 超级管理员：直接点击确定处理反馈
    finishFeedbackItem(item) {
      this.$confirm('确定处理完成该反馈吗？完成后用户将看到"已完成"状态。', '处理反馈', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.fbFinishingId = item.id
        finishFeedback({
          id: item.id,
          operatorRole: this.user.roleId,
          operatorNo: this.user.no,
          operatorName: this.user.name || ''
        }).then(res => {
          if (res.code === 200) {
            this.$message.success('反馈已处理完成')
            this.loadManageFeedback()
          } else {
            this.$message.error(res.msg || '处理失败，请稍后重试')
          }
        }).catch(err => {
          this.$message.error(err.message || '网络异常，请稍后重试')
        }).finally(() => {
          this.fbFinishingId = null
        })
      }).catch(() => {
        // 用户取消
      })
    },
    // 提交反馈
    doFeedback() {
      const content = (this.feedbackForm.content || '').trim()
      if (!content) {
        this.$message.warning('请先填写反馈内容')
        return
      }
      if (!this.user || !this.user.no) {
        this.$message.warning('请先登录后再提交反馈')
        return
      }
      this.feedbackSending = true
      addFeedback({
        no: this.user.no,
        name: this.user.name || '',
        content
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('反馈提交成功，感谢你的建议 🌸')
          this.feedbackForm.content = ''
          this.loadMyFeedback()
        } else {
          this.$message.error(res.msg || '提交失败，请稍后重试')
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后重试')
      }).finally(() => {
        this.feedbackSending = false
      })
    },
    resetFeedbackForm() {
      this.feedbackForm = { content: '' }
      this.feedbackList = []
      this.fbManageList = []
      this.fbFinishingId = null
    },

    // ===== 系统通知卡片 =====
    openNoticeCard() {
      this.noticeView = 'list'
      this.noticeVisible = true
    },
    onNoticeOpen() {
      this.loadMyNotices(true)
      this.refreshUnread()
    },
    onNoticeClosed() {
      this.noticeList = []
      this.noticeTotal = 0
      this.noticePage = 1
      this.currentNotice = null
    },
    // 加载我的通知：reset=true 重置分页，false 追加下一页
    loadMyNotices(reset) {
      if (!this.user || !this.user.no) return
      if (reset) {
        this.noticePage = 1
      } else if (this.noticeLoading || this.noticeList.length >= this.noticeTotal) {
        return
      }
      this.noticeLoading = true
      myNotices({
        pageNum: this.noticePage,
        pageSize: this.noticePageSize,
        param: { no: this.user.no }
      }).then(res => {
        if (res.code === 200) {
          const list = res.data || []
          this.noticeList = reset ? list : this.noticeList.concat(list)
          this.noticeTotal = Number(res.total || 0)
          this.noticePage++
        } else {
          this.$message.error(res.msg || '获取通知失败')
        }
      }).catch(err => {
        this.$message.error(err.message || '网络异常，请稍后重试')
      }).finally(() => {
        this.noticeLoading = false
      })
    },
    // 点击通知条：未读先标记已读，再展示内容
    showNoticeDetail(item) {
      if (item.isRead !== 'Y') {
        readNotice({ no: this.user.no, noticeId: item.noticeId }).then(() => {
          item.isRead = 'Y'
          if (this.unreadNoticeCount > 0) this.unreadNoticeCount--
          this.refreshUnread()
        }).catch(() => {
          // 标记已读失败不阻断查看内容
        })
      }
      this.currentNotice = item
      this.noticeView = 'detail'
    },
    // 刷新头部未读角标
    refreshUnread() {
      if (!this.user || !this.user.no) {
        this.unreadNoticeCount = 0
        return
      }
      unreadCount(this.user.no).then(res => {
        if (res.code === 200) {
          this.unreadNoticeCount = Number(res.data || 0)
        }
      }).catch(() => {
        // 角标获取失败保持原值，不打扰用户
      })
    },
    // ===== 每日首次登录：用户须知和安全协议 =====
    checkDailyNotice() {
      // 超级管理员不弹
      if (this.user.roleId === 0) return
      // 每次登录都弹出；仅当用户今天勾选过“今天不再弹出”时才跳过
      const today = this.todayKey()
      let optedOut = ''
      try {
        optedOut = localStorage.getItem('pinkSkirtDailyNoticeOptOut') || ''
      } catch (e) {
        optedOut = ''
      }
      if (optedOut !== today) {
        this.dailySkipToday = false
        this.dailyNoticeVisible = true
      }
    },
    closeDailyNotice() {
      if (this.dailySkipToday) {
        try {
          localStorage.setItem('pinkSkirtDailyNoticeOptOut', this.todayKey())
        } catch (e) {
          // 隐私模式等场景下写失败则本次会话内不再重复弹出
          sessionStorage.setItem('pinkSkirtDailyNoticeOptOut', this.todayKey())
        }
      }
      this.dailyNoticeVisible = false
    },
    todayKey() {
      const d = new Date()
      return d.getFullYear() + '-' + (d.getMonth() + 1 < 10 ? '0' : '') + (d.getMonth() + 1) + '-' +
          (d.getDate() < 10 ? '0' : '') + d.getDate()
    },
    wu() {
      // 用轻量 toast 替代 $confirm 确认框：确认框与登录抽屉（modal-append-to-body=false）
      // 叠加时，Element UI 的弹层清理可能中断，残留全屏遮罩与 body 滚动锁，
      // 导致整页无法滚动（“有时候首页滑不动”的根因）
      this.$message.warning('忘记密码请联系管理员在系统内重置哦')
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: '爱心字体';
  src:url("../assets/fonts/爱心字体.ttf");
}
/* ===== 导航条整体：流式 flex 布局，logo / 菜单 / 用户区同排互不遮挡 ===== */
.header-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  z-index: 998;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  background: linear-gradient(
      45deg,
      #bafff2,
      #affcc1,
      #90e8fc,
      #fcbce8,
      #8fbdf6,
      #dda0f1
  );
  background-size: 400% 400%;
  animation: gradientFlowDiagonal 15s ease infinite;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* ===== 自动隐藏：默认正常显示，隐藏态整体向上滑出并淡出 ===== */
.header-nav.nav-autohide {
  transition: transform 0.55s cubic-bezier(0.4, 0, 0.2, 1),
              opacity 0.45s ease;
  will-change: transform, opacity;
}

.header-nav.nav-autohide.nav-hidden {
  transform: translateY(-100%);
  opacity: 0;
  pointer-events: none;
}

/* 去掉 el-menu 默认白底与下边框；绝对定位在头部正中央，不受左右区域宽度影响 */
.header-nav :deep(.el-menu) {
  background: transparent;
  border-bottom: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  white-space: nowrap;
}

/* 导航项：统一使用清晰的中文字体，字号略放大，颜色跟随主题 */
.header-nav :deep(.el-menu--horizontal > .el-menu-item),
.header-nav :deep(.el-menu--horizontal > .el-submenu .el-submenu__title) {
  height: 60px;
  font-family: '爱心字体', sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 60px;
  padding: 0 12px;
  flex-shrink: 0;
  transition: color 0.2s ease, background-color 0.2s ease;
}

/* 悬停：柔和白色半透明底 + 主题粉，替代 Element 默认蓝色底 */
.header-nav :deep(.el-menu--horizontal > .el-menu-item:hover),
.header-nav :deep(.el-menu--horizontal > .el-submenu .el-submenu__title:hover) {
  background-color: rgba(255, 255, 255, 0.45);
  color: #e0539c;
}

/* 激活态：主题粉文字 + 粉白下划线，替代默认蓝色 */
.header-nav :deep(.el-menu--horizontal > .el-menu-item.is-active),
.header-nav :deep(.el-menu--horizontal > .el-submenu.is-active .el-submenu__title) {
  color: #e0539c;
  border-bottom: 2px solid #e0539c;
}

/* ===== “更多”小抽屉：软萌粉面板，点击“更多”在下方弹出 ===== */
.more-menu-item.more-active {
  background-color: rgba(255, 255, 255, 0.45);
  color: #e0539c;
}

.more-drawer {
  position: absolute;
  z-index: 1200;
  min-width: 380px;
  padding: 12px;
  box-sizing: border-box;
  background: linear-gradient(160deg, #fff7fb, #ffe9f2 55%, #ffdcea);
  border: 1px solid rgba(224, 83, 156, 0.28);
  border-radius: 16px;
  box-shadow: 0 10px 28px rgba(224, 83, 156, 0.28);
  user-select: none;
}

/* 两列网格排布 */
.more-drawer-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.more-drawer-arrow {
  position: absolute;
  top: -6px;
  width: 12px;
  height: 12px;
  background: #ffe9f2;
  border-left: 1px solid rgba(224, 83, 156, 0.28);
  border-top: 1px solid rgba(224, 83, 156, 0.28);
  transform: rotate(45deg);
}

.more-drawer-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding-bottom: 8px;
  margin-bottom: 6px;
  border-bottom: 1px dashed rgba(224, 83, 156, 0.3);
}

.more-drawer-title {
  font-family: '爱心字体', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #e0539c;
}

.more-drawer-sub {
  font-size: 11px;
  color: #c98ba5;
}

.more-drawer-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 12px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(224, 83, 156, 0.14);
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.more-drawer-item:hover {
  background: rgba(255, 255, 255, 0.92);
  border-color: rgba(224, 83, 156, 0.35);
  box-shadow: 0 4px 12px rgba(224, 83, 156, 0.15);
  transform: translateY(-2px);
}

.more-drawer-icon {
  font-size: 22px;
  flex-shrink: 0;
}

.more-drawer-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.more-drawer-name-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  min-width: 0;
}

.more-drawer-name {
  font-family: '爱心字体', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #b04a76;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.more-drawer-desc {
  font-size: 11px;
  color: #c98ba5;
}

.more-drawer-badge {
  flex-shrink: 0;
  font-size: 10px;
  color: #fff;
  background: linear-gradient(135deg, #ffa3c9, #e0539c);
  border-radius: 999px;
  padding: 1px 6px;
}

.more-drawer-fade-enter-active,
.more-drawer-fade-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.more-drawer-fade-enter,
.more-drawer-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@keyframes gradientFlowDiagonal {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}

/* ===== 左侧 Logo（流式布局，不再悬浮遮挡菜单） ===== */
.login-logo {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.logo-icon {
  width: 60px;
  display: block;
}

.logo-text {
  width: 180px;
  display: block;
}

/* ===== 双击全屏引导气泡 ===== */
.fs-tip {
  position: absolute;
  top: calc(100% + 12px);
  left: 8px;
  z-index: 999;
  max-width: 250px;
  padding: 9px 14px;
  white-space: nowrap;
  background: linear-gradient(135deg, #fff2f8, #ffe6f0);
  border: 1px solid #f3a9c6;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(224, 83, 156, 0.22);
  color: #b04a76;
  font-size: 13px;
  line-height: 1.5;
  cursor: default;
  user-select: none;
}
.fs-tip-arrow {
  position: absolute;
  top: -7px;
  left: 30px;
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #ffe6f0;
}
.fs-tip-enter-active,
.fs-tip-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fs-tip-enter,
.fs-tip-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* logo1（星星雨）引导气泡：纵向错开在全屏气泡下方，避免两者重叠 */
.star-tip {
  top: calc(100% + 60px);
}
.star-tip-arrow {
  left: 20px;
}

/* ===== 手机端汉堡菜单（桌面隐藏，移动端显示） ===== */
.nav-mobile-menu {
  display: none;
}

/* ===== 右侧登录 / 用户状态 ===== */
.header-user-area {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.header-login-btn {
  font-weight: bold;
}

.header-back-btn {
  font-weight: bold;
  margin-right: 10px;
}

.header-user-name {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(238, 137, 183, 0.5);
  color: #c9578b;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(255, 194, 218, 0.5);
  cursor: pointer;
  outline: none;
}

.header-user-name i {
  margin-right: 5px;
}

/* ===== 右侧滑出抽屉 ===== */
:deep(.login-drawer) {
  background: linear-gradient(160deg, #fff5fa, #f0f9ff);
  border-radius: 18px 0 0 18px;
}

.drawer-card {
  padding: 30px 28px;
  height: 100%;
  box-sizing: border-box;
}

.drawer-head {
  text-align: center;
  margin-bottom: 18px;
}

.drawer-title {
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 2px;
}

.drawer-sub {
  margin-top: 8px;
  color: #a06b83;
  font-size: 13px;
}

.drawer-tabs {
  margin-top: 6px;
}

:deep(.drawer-tabs .el-tabs__item) {
  font-size: 15px;
  font-weight: bold;
}

:deep(.drawer-tabs .el-tabs__item.is-active) {
  color: #e0539c;
}

:deep(.drawer-tabs .el-tabs__active-bar) {
  background-color: #e0539c;
}

.drawer-form {
  margin-top: 8px;
}

.drawer-sex-row {
  display: flex;
  align-items: center;
  height: 40px;
}

.drawer-sex-label {
  width: 48px;
  color: #606266;
  font-size: 14px;
  flex-shrink: 0;
}

:deep(.drawer-sex-row .el-radio__label) {
  color: #606266;
}

.drawer-submit {
  width: 100%;
  font-size: 15px;
  letter-spacing: 8px;
  border-radius: 20px;
  margin-top: 4px;
}

.drawer-tip {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2px;
}

.drawer-switch {
  color: #409eff;
  font-size: 13px;
  cursor: pointer;
}

.drawer-switch:hover {
  color: #e0539c;
}

/* 登录抽屉：账号安全须知 */
.login-security-box {
  margin-top: 12px;
  margin-bottom: 16px;
  padding: 10px 12px;
  border: 1px solid #ffe0ef;
  border-radius: 10px;
  background: #fffafd;
}

.login-security-title {
  font-size: 13px;
  font-weight: bold;
  color: #c2457c;
  text-align: center;
  margin-bottom: 6px;
}

.login-security-text p {
  margin: 5px 0;
  font-size: 12px;
  line-height: 1.7;
  color: #6b4a5e;
}

/* 抽屉标题渐变流光文字 */
.chou_text_color2 {
  background-image: -webkit-linear-gradient(left, pink, #7edbff 10%, #f16a9d 20%, #fa5d50 30%, #C0B2FC 40%, #98E4FB 50%, #C0B2FC 60%, #fa5d50 70%, #f16a9d 80%, #7edbff 90%, pink 100%);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-background-size: 200% 100%;
  -webkit-animation: chou_text_color 4s linear infinite;
}

@keyframes chou_text_color {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: -100% 0;
  }
}

/* ===== 个人设置弹窗 ===== */
:deep(.profile-dialog .el-dialog__title) {
  color: #c2457c;
  font-weight: 700;
}

:deep(.profile-dialog .el-dialog__header) {
  background: linear-gradient(160deg, #fff2f8, #ffe6f0);
}

:deep(.profile-dialog .el-dialog__body) {
  background: #fffafd;
}

:deep(.profile-dialog) {
  border-radius: 20px;
  overflow: hidden;
}

.profile-edit {
  padding: 6px 10px;
}

.profile-avatar-uploader {
  display: block;
  text-align: center;
  margin-bottom: 18px;
  cursor: pointer;
}

.profile-avatar {
  background: linear-gradient(135deg, #ff9ec3, #f0619c);
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.profile-avatar-uploader:hover .profile-avatar {
  transform: scale(1.06);
  box-shadow: 0 6px 18px rgba(240, 97, 156, 0.5);
}

.profile-avatar-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #c78ca6;
}

.profile-form {
  margin-top: 4px;
}

/* ===== 系统通知：下拉角标 ===== */
.header-notice-badge {
  display: inline-block;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  padding: 0 5px;
  margin-left: 8px;
  border-radius: 8px;
  background: #f56c6c;
  color: #fff;
  font-size: 11px;
  text-align: center;
  vertical-align: middle;
}

/* ===== 注册抽屉：用户协议 ===== */
.drawer-agreement {
  margin-top: 2px;
}

.drawer-agreement-box {
  max-height: 350px;
  overflow-y: auto;
  padding: 10px 6px 10px 10px;
  border: 1px solid #ffe0ef;
  border-radius: 10px;
  background: #fffafd;
}

.drawer-agreement-title {
  font-size: 14px;
  font-weight: bold;
  color: #c2457c;
  text-align: center;
  margin-bottom: 6px;
}

.drawer-agreement-text p {
  margin: 6px 0;
  font-size: 12px;
  line-height: 1.7;
  color: #6b4a5e;
  text-align: justify;
}

.drawer-agreement-check {
  margin-top: 10px;
  font-size: 13px;
  color: #6b4a5e;
}

.agreement-link {
  color: #e0539c;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
}

.agreement-link:hover {
  color: #c2457c;
}

/* ===== 用户协议完整弹窗 ===== */
.agreement-full {
  max-height: 56vh;
  overflow-y: auto;
  padding: 4px 10px;
}

/* 用户协议内容区：细滚动条 */
.agreement-full::-webkit-scrollbar,
.drawer-agreement-box::-webkit-scrollbar {
  width: 4px;
}

.agreement-full::-webkit-scrollbar-thumb,
.drawer-agreement-box::-webkit-scrollbar-thumb {
  background: #f0b6cf;
  border-radius: 4px;
}

.agreement-full::-webkit-scrollbar-track,
.drawer-agreement-box::-webkit-scrollbar-track {
  background: transparent;
}

.agreement-full,
.drawer-agreement-box {
  scrollbar-width: thin;
  scrollbar-color: #f0b6cf transparent;
}

.agreement-full p {
  margin: 8px 0;
  font-size: 13px;
  line-height: 1.8;
  color: #5a4450;
  text-align: justify;
}

/* 用户协议弹窗：20px 圆角、body 内边距 30px 10px、标题居中 */
:deep(.agreement-dialog) {
  border-radius: 20px;
  overflow: hidden;
}

:deep(.agreement-dialog .el-dialog__body) {
  padding: 30px 10px;
}

:deep(.agreement-dialog .el-dialog__title) {
  display: block;
  text-align: center;
}

/* ===== 系统通知卡片弹窗 ===== */
:deep(.notice-dialog) {
  border-radius: 20px;
  overflow: hidden;
}

:deep(.notice-dialog .el-dialog__title) {
  color: #c2457c;
  font-weight: 700;
}

:deep(.notice-dialog .el-dialog__header) {
  background: linear-gradient(160deg, #fff2f8, #ffe6f0);
}

.notice-card {
  min-height: 220px;
}

.notice-empty {
  padding: 60px 0;
  text-align: center;
  color: #c78ca6;
  font-size: 13px;
}

.notice-empty i {
  font-size: 40px;
  color: #ffd0e6;
  display: block;
  margin-bottom: 8px;
}

.notice-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.notice-item {
  padding: 12px 14px;
  border-radius: 12px;
  margin-bottom: 8px;
  background: #fff7fb;
  border: 1px solid #ffe0ef;
  cursor: pointer;
  transition: box-shadow 0.2s ease, background-color 0.2s ease;
}

.notice-item.is-unread {
  background: linear-gradient(90deg, #fff0f7, #fff7fb);
  border-color: #ffb3d4;
}

.notice-item:hover {
  box-shadow: 0 4px 14px rgba(224, 83, 156, 0.16);
}

.notice-item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.notice-item-title {
  font-size: 14px;
  font-weight: 700;
  color: #4a2c40;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-item-meta {
  margin-top: 6px;
  font-size: 12px;
  color: #b07790;
  display: flex;
  justify-content: space-between;
}

.notice-item-time {
  color: #c79ab2;
}

.notice-more {
  text-align: center;
  padding: 10px 0 4px;
  color: #e0539c;
  font-size: 13px;
  cursor: pointer;
}

.notice-more:hover {
  color: #c2457c;
}

.notice-detail {
  padding: 6px 4px;
}

.notice-detail-title {
  font-size: 17px;
  font-weight: 700;
  color: #4a2c40;
  margin-bottom: 8px;
}

.notice-detail-meta {
  font-size: 12px;
  color: #b07790;
  margin-bottom: 14px;
}

.notice-detail-content {
  font-size: 14px;
  line-height: 1.9;
  color: #5a4450;
  white-space: pre-wrap;
  word-break: break-word;
  padding: 14px;
  border-radius: 12px;
  background: #fff7fb;
  border: 1px solid #ffe0ef;
}

.notice-detail-back {
  margin-top: 14px;
  font-size: 13px;
  color: #e0539c;
  cursor: pointer;
}

.notice-detail-back:hover {
  color: #c2457c;
}

/* ===== 每日首次登录：用户须知和安全协议 ===== */
.daily-notice-content {
  max-height: 52vh;
  overflow-y: auto;
  padding: 4px 10px;
}

.daily-notice-content p {
  margin: 8px 0;
  font-size: 13px;
  line-height: 1.8;
  color: #5a4450;
  text-align: justify;
}

.daily-notice-optout {
  float: left;
  margin-top: 5px;
}

/* 每日首次登录弹窗：圆角 10px */
:deep(.daily-notice-dialog) {
  border-radius: 10px;
  overflow: hidden;
}

/* ===== 帮助反馈弹窗 ===== */
:deep(.feedback-dialog) {
  border-radius: 20px;
  overflow: hidden;
}

:deep(.feedback-dialog .el-dialog__title) {
  color: #c2457c;
  font-weight: 700;
}

:deep(.feedback-dialog .el-dialog__header) {
  background: linear-gradient(160deg, #fff2f8, #ffe6f0);
}

.feedback-send {
  padding: 6px 4px 2px;
}

.feedback-send-title {
  font-size: 14px;
  font-weight: 600;
  color: #6b4a5e;
  margin-bottom: 10px;
}

.feedback-send-actions {
  margin-top: 12px;
  text-align: center;
}

.feedback-list-title {
  font-size: 14px;
  font-weight: 600;
  color: #6b4a5e;
  margin: 18px 0 10px;
}

.feedback-empty {
  padding: 30px 0;
  text-align: center;
  color: #c78ca6;
  font-size: 13px;
}

.feedback-empty i {
  font-size: 36px;
  color: #ffd0e6;
  display: block;
  margin-bottom: 8px;
}

.feedback-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 320px;
  overflow-y: auto;
}

.feedback-list::-webkit-scrollbar {
  width: 4px;
}

.feedback-list::-webkit-scrollbar-thumb {
  background: #f0b6cf;
  border-radius: 4px;
}

.feedback-item {
  padding: 12px 14px;
  border-radius: 12px;
  margin-bottom: 8px;
  background: #fff7fb;
  border: 1px solid #ffe0ef;
}

.feedback-item-user {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.feedback-user-name {
  font-size: 13px;
  font-weight: 700;
  color: #c2457c;
}

.feedback-user-no {
  font-size: 12px;
  color: #b07790;
  background: #ffeef7;
  border-radius: 8px;
  padding: 1px 8px;
}

.feedback-item-actions {
  margin-top: 8px;
  text-align: right;
}

.feedback-done-text {
  font-size: 13px;
  color: #3fa66f;
  font-weight: 600;
}

.feedback-item-content {
  font-size: 14px;
  line-height: 1.7;
  color: #4a2c40;
  white-space: pre-wrap;
  word-break: break-word;
}

.feedback-item-meta {
  margin-top: 8px;
  font-size: 12px;
  color: #b07790;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.feedback-item-finish {
  margin-top: 6px;
  font-size: 12px;
  color: #3fa66f;
}

/* ================= 手机端适配（≤767px） ================= */
@media (max-width: 767px) {
  .header-nav {
    padding: 0 10px;
  }

  /* 中央菜单收起为汉堡菜单 */
  .header-nav :deep(.el-menu) {
    display: none;
  }

  .nav-mobile-menu {
    display: inline-flex;
    margin-left: 6px;
    align-items: center;
  }

  .nav-mobile-btn {
    font-size: 26px;
    color: #c9578b;
    padding: 6px;
    cursor: pointer;
  }

  /* Logo 缩小 */
  .logo-icon {
    width: 38px;
  }

  .logo-text {
    width: 108px;
  }

  /* 引导气泡箭头对准缩小的 Logo 图标中心 */
  .fs-tip-arrow {
    left: 19px;
  }

  /* 移动端 logo1 引导气泡：左移到缩小后的 Logo1 下方，箭头对准其中心 */
  .star-tip {
    left: 60px !important;
  }
  .star-tip-arrow {
    left: 32px;
  }

  /* 右侧用户区压缩 */
  .header-user-name {
    font-size: 13px;
    padding: 0 10px;
  }

  /* 登录抽屉：手机端全宽 */
  :deep(.login-drawer) {
    width: 100% !important;
    border-radius: 0;
  }

  /* 各弹窗宽度适配手机 */
  :deep(.profile-dialog),
  :deep(.notice-dialog),
  :deep(.agreement-dialog),
  :deep(.daily-notice-dialog),
  :deep(.feedback-dialog) {
    width: 92% !important;
    max-width: 92%;
  }
}
</style>

<style>
/* ===== 星星雨全局样式（星星由 JS 动态创建，必须放在非 scoped 块才能命中） ===== */
.star-rain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 996;
}
.star-rain-item {
  position: absolute;
  left: 0;
  top: 0;
  line-height: 1;
  text-shadow: 0 0 8px currentColor;
  will-change: transform, opacity;
}

/* ===== 星星雨配置小卡片（软萌粉系毛玻璃） ===== */
.star-rain-config {
  position: fixed;
  top: 64px;
  right: 16px;
  width: 232px;
  z-index: 1010;
  background: rgba(255, 245, 250, 0.88);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(224, 83, 156, 0.25);
  border-radius: 14px;
  box-shadow: 0 8px 28px rgba(224, 83, 156, 0.18);
  padding: 12px 14px 10px;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  user-select: none;
  pointer-events: auto;
}
.srcfg-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.srcfg-title {
  font-size: 14px;
  font-weight: 700;
  color: #e0539c;
}
.srcfg-close {
  border: none;
  background: transparent;
  color: #c96a90;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  padding: 0 2px;
}
.srcfg-close:hover { color: #e0539c; }
.srcfg-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.srcfg-label {
  width: 52px;
  flex-shrink: 0;
  font-size: 12px;
  color: #8a4a63;
}
.srcfg-range {
  flex: 1;
  accent-color: #e0539c;
}
.srcfg-val {
  width: 26px;
  text-align: right;
  font-size: 12px;
  color: #e0539c;
  font-weight: 600;
}
.srcfg-modes {
  display: flex;
  gap: 6px;
}
.srcfg-mode {
  border: 1px solid rgba(224, 83, 156, 0.3);
  background: #fff;
  color: #a04a6e;
  font-size: 12px;
  border-radius: 10px;
  padding: 3px 9px;
  cursor: pointer;
}
.srcfg-mode.on {
  background: #ffd9ea;
  border-color: #e0539c;
  color: #e0539c;
  font-weight: 600;
}
.srcfg-palettes {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.srcfg-pal {
  border: 2px solid transparent;
  border-radius: 9px;
  padding: 3px 7px;
  font-size: 11px;
  color: #fff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  cursor: pointer;
}
.srcfg-pal.on {
  border-color: #e0539c;
  outline: 1px solid #e0539c;
}
.srcfg-solids {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.srcfg-solid {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.7);
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}
.srcfg-solid.on {
  border-color: #e0539c;
  box-shadow: 0 0 0 2px rgba(224, 83, 156, 0.4);
}
.srcfg-tip {
  margin-top: 8px;
  font-size: 11px;
  color: #b08a97;
  text-align: center;
}
.srcfg-btns {
  margin-top: 10px;
  justify-content: center;
}
.srcfg-pause {
  flex: 1;
  border: 1px solid rgba(224, 83, 156, 0.35);
  background: #ffd9ea;
  color: #e0539c;
  font-size: 12px;
  font-weight: 600;
  border-radius: 10px;
  padding: 5px 10px;
  cursor: pointer;
  transition: all 0.2s;
}
.srcfg-pause:hover {
  background: #ffc7de;
}
.srcfg-pause.paused {
  background: #e0539c;
  color: #fff;
}
/* 星星雨悬浮球：卡片收起后的迷你入口 */
.star-rain-ball {
  position: fixed;
  top: 70px;
  right: 10px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffd1e8, #e0539c);
  color: #fff;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1010;
  box-shadow: 0 4px 16px rgba(224, 83, 156, 0.45);
  animation: starRainBallPulse 2.4s ease-in-out infinite;
  user-select: none;
  transition: transform 0.2s;
}
.star-rain-ball:hover {
  transform: scale(1.12);
}
@keyframes starRainBallPulse {
  0%, 100% { box-shadow: 0 4px 16px rgba(224, 83, 156, 0.45); }
  50% { box-shadow: 0 4px 22px rgba(224, 83, 156, 0.75); }
}

/* ===== “更多”小抽屉：点击菜单项后的粉色提示气泡（消息挂在 body，须全局） ===== */
.more-tip-message {
  background: linear-gradient(135deg, #fff2f8, #ffe6f0) !important;
  border: 1px solid #f3a9c6 !important;
  border-radius: 10px !important;
  box-shadow: 0 8px 20px rgba(224, 83, 156, 0.25) !important;
}
.more-tip-message .el-message__content {
  color: #b04a76 !important;
  font-family: '爱心字体', sans-serif;
  font-size: 14px;
}
</style>
